import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { applyContainerQuery } from 'react-container-query';
import {
  containerQueryConstants,
  containerQueryProps,
} from '@resy/ui-kitchen';

import BlogContentContainer from '../../containers/BlogContentContainer';
import AllCitiesContainer from '../../containers/AllCitiesContainer';

import './Header.scss';

const Header = (props) => {
  const {
    containerQuery,
    selectedLocation,
    showAllCities,
    $rootScope,
    $window,
    locationCode,
    locationTier,
    ...passThroughProps
  } = props;

  const header = selectedLocation?.metadata?.all_cities?.header;
  const tagline = selectedLocation?.metadata?.all_cities?.tagline;

  return (
    <div className="Header container">
      {!showAllCities && (
        <BlogContentContainer
          locationCode={locationCode}
          locationTier={locationTier}
          containerQuery={containerQuery}
          $rootScope={$rootScope}
          {...passThroughProps}
        />
      )}
      {showAllCities && (
        <AllCitiesContainer
          locationCode={locationCode}
          locationTier={locationTier}
          containerQuery={containerQuery}
          header={header}
          tagline={tagline}
          $rootScope={$rootScope}
          $window={$window}
          {...passThroughProps}
        />
      )}
    </div>
  );
};

const headerPropTypes = {
  containerQuery: containerQueryProps,
  selectedLocation: PropTypes.shape({
    metadata: PropTypes.shape({
      all_cities: PropTypes.shape({
        header: PropTypes.string,
        tagline: PropTypes.string,
      }),
    }),
  }),
  showAllCities: PropTypes.bool,
  $rootScope: PropTypes.shape({}).isRequired,
  $window: PropTypes.shape({}).isRequired,
  locationCode: PropTypes.string,
  locationTier: PropTypes.number,
};

Header.propTypes = headerPropTypes;

Header.defaultProps = {
  containerQuery: {},
  selectedLocation: {
    metadata: {
      all_cities: {},
    },
  },
  showAllCities: false,
  locationCode: undefined,
  locationTier: undefined,
};

Header.displayName = 'Header';

const mapStateToProps = ({ resyLocations }) => ({
  locationCode: resyLocations.selected?.code,
  locationTier: resyLocations.selected?.content_tier,
});

const WrappedHeader = (props) => (
  <div className="WrappedHeader">
    <Header {...props} />
  </div>
);

// Naming and structure of these wrapped items is a mess, and not trying to sort it out here.
// See WrappedAuthContainer for a similar and consistent naming and implemenation.
const ContainerQueryWrappedHeader = applyContainerQuery(WrappedHeader, containerQueryConstants);

export { Header as HeaderComponent, WrappedHeader, headerPropTypes };
export default connect(mapStateToProps)(ContainerQueryWrappedHeader);
